var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayDownloadBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 48,
    viewBox: "0 0 166 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.78 48H6.14539C2.76696 48 0 45.2985 0 42V6.00001C0 2.70151 2.76696 7.26094e-06 6.14539 7.26094e-06H159.78C163.158 7.26094e-06 165.925 2.70151 165.925 6.00001V42C165.925 45.2985 163.158 48 159.78 48Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.78 0.961508C162.625 0.961508 164.941 3.22201 164.941 6.00001V42C164.941 44.778 162.625 47.0385 159.78 47.0385H6.14539C3.30007 47.0385 0.984798 44.778 0.984798 42V6.00001C0.984798 3.22201 3.30007 0.961508 6.14539 0.961508H159.78ZM159.78 7.26094e-06H6.14539C2.76696 7.26094e-06 0 2.70151 0 6.00001V42C0 45.2985 2.76696 48 6.14539 48H159.78C163.158 48 165.925 45.2985 165.925 42V6.00001C165.925 2.70151 163.158 7.26094e-06 159.78 7.26094e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2799 12.2924C58.2799 13.2944 57.9726 14.0969 57.3673 14.6954C56.6713 15.4049 55.7649 15.7619 54.6541 15.7619C53.5925 15.7619 52.686 15.3989 51.9424 14.6834C51.1973 13.9574 50.8255 13.0664 50.8255 11.9999C50.8255 10.9334 51.1973 10.0424 51.9424 9.32237C52.686 8.60087 53.5925 8.23787 54.6541 8.23787C55.1826 8.23787 55.6865 8.34437 56.1674 8.54237C56.6467 8.74187 57.0369 9.01187 57.3196 9.34487L56.6774 9.97787C56.1843 9.40937 55.5129 9.12887 54.6541 9.12887C53.8798 9.12887 53.2084 9.39287 52.6384 9.92537C52.0746 10.4594 51.7919 11.1509 51.7919 11.9999C51.7919 12.8489 52.0746 13.5464 52.6384 14.0804C53.2084 14.6069 53.8798 14.8769 54.6541 14.8769C55.476 14.8769 56.1674 14.6069 56.7128 14.0744C57.0723 13.7219 57.2766 13.2359 57.3304 12.6149H54.6541V11.7479H58.2245C58.2676 11.9354 58.2799 12.1169 58.2799 12.2924Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9443 9.28649H60.5905V11.5665H63.614V12.4335H60.5905V14.7135H63.9443V15.597H59.641V8.40299H63.9443V9.28649Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9419 15.597H66.9924V9.28649H64.9352V8.40299H70.0006V9.28649H67.9419V15.597Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6658 15.5968V8.40279H74.6138V15.5968H73.6658Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8164 15.5971H77.8747V9.28664H75.8098V8.40314H80.8813V9.28664H78.8164V15.5971Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4705 14.6717C89.7438 15.3992 88.8435 15.7622 87.7696 15.7622C86.6895 15.7622 85.7892 15.3992 85.0625 14.6717C84.3374 13.9457 83.9763 13.0547 83.9763 12.0002C83.9763 10.9457 84.3374 10.0547 85.0625 9.3287C85.7892 8.60121 86.6895 8.2382 87.7696 8.2382C88.8373 8.2382 89.7376 8.6012 90.4643 9.3347C91.1956 10.0667 91.5567 10.9517 91.5567 12.0002C91.5567 13.0547 91.1956 13.9457 90.4705 14.6717ZM85.7646 14.0687C86.3116 14.6072 86.9768 14.8772 87.7696 14.8772C88.5562 14.8772 89.2276 14.6072 89.7683 14.0687C90.3138 13.5302 90.5903 12.8387 90.5903 12.0002C90.5903 11.1617 90.3138 10.4702 89.7683 9.93171C89.2276 9.39321 88.5562 9.1232 87.7696 9.1232C86.9768 9.1232 86.3116 9.39321 85.7646 9.93171C85.2192 10.4702 84.9427 11.1617 84.9427 12.0002C84.9427 12.8387 85.2192 13.5302 85.7646 14.0687Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.889 15.597V8.40299H94.0413L97.6241 13.998H97.6655L97.6241 12.615V8.40299H98.572V15.597H97.5826L93.8308 9.72599H93.7893L93.8308 11.115V15.597H92.889Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.147692,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7431 26.103C80.8563 26.103 78.498 28.248 78.498 31.2075C78.498 34.143 80.8563 36.3105 83.7431 36.3105C86.6361 36.3105 88.9944 34.143 88.9944 31.2075C88.9944 28.248 86.6361 26.103 83.7431 26.103ZM83.7431 34.3005C82.1592 34.3005 80.7964 33.024 80.7964 31.2075C80.7964 29.367 82.1592 28.113 83.7431 28.113C85.3271 28.113 86.696 29.367 86.696 31.2075C86.696 33.024 85.3271 34.3005 83.7431 34.3005ZM72.2989 26.103C69.4059 26.103 67.0538 28.248 67.0538 31.2075C67.0538 34.143 69.4059 36.3105 72.2989 36.3105C75.1903 36.3105 77.544 34.143 77.544 31.2075C77.544 28.248 75.1903 26.103 72.2989 26.103ZM72.2989 34.3005C70.7134 34.3005 69.346 33.024 69.346 31.2075C69.346 29.367 70.7134 28.113 72.2989 28.113C73.8829 28.113 75.2456 29.367 75.2456 31.2075C75.2456 33.024 73.8829 34.3005 72.2989 34.3005ZM58.6807 27.6675V29.8365H63.9857C63.8305 31.0485 63.4157 31.9395 62.7797 32.5605C62.0054 33.3105 60.7993 34.143 58.6807 34.143C55.416 34.143 52.8595 31.5705 52.8595 28.383C52.8595 25.1955 55.416 22.623 58.6807 22.623C60.446 22.623 61.7304 23.2965 62.6783 24.1695L64.2438 22.641C62.918 21.405 61.1542 20.4555 58.6807 20.4555C54.2038 20.4555 50.4413 24.012 50.4413 28.383C50.4413 32.754 54.2038 36.3105 58.6807 36.3105C61.1005 36.3105 62.918 35.5365 64.3468 34.0845C65.8109 32.655 66.2672 30.645 66.2672 29.022C66.2672 28.518 66.2242 28.0545 66.1474 27.6675H58.6807ZM114.367 29.349C113.935 28.2075 112.603 26.103 109.89 26.103C107.202 26.103 104.963 28.1715 104.963 31.2075C104.963 34.0665 107.179 36.3105 110.148 36.3105C112.55 36.3105 113.935 34.881 114.505 34.0485L112.723 32.889C112.129 33.738 111.319 34.3005 110.148 34.3005C108.985 34.3005 108.151 33.78 107.616 32.754L114.608 29.9295L114.367 29.349ZM107.238 31.0485C107.179 29.0805 108.804 28.0725 109.969 28.0725C110.881 28.0725 111.655 28.518 111.914 29.1555L107.238 31.0485ZM101.556 36H103.854V21H101.556V36ZM97.7915 27.24H97.7147C97.1984 26.643 96.2137 26.103 94.9661 26.103C92.3482 26.103 89.9546 28.347 89.9546 31.224C89.9546 34.0845 92.3482 36.3105 94.9661 36.3105C96.2137 36.3105 97.1984 35.766 97.7147 35.151H97.7915V35.883C97.7915 37.8345 96.7237 38.883 95.0015 38.883C93.5972 38.883 92.7261 37.893 92.3666 37.0605L90.3678 37.875C90.944 39.228 92.4696 40.893 95.0015 40.893C97.6962 40.893 99.97 39.345 99.97 35.5785V26.4135H97.7915V27.24ZM95.1628 34.3005C93.5788 34.3005 92.2529 33.006 92.2529 31.224C92.2529 29.4255 93.5788 28.113 95.1628 28.113C96.7237 28.113 97.9543 29.4255 97.9543 31.224C97.9543 33.006 96.7237 34.3005 95.1628 34.3005ZM125.128 21H119.631V36H121.923V30.3165H125.128C127.673 30.3165 130.17 28.518 130.17 25.6575C130.17 22.7985 127.667 21 125.128 21ZM125.188 28.23H121.923V23.0865H125.188C126.899 23.0865 127.876 24.474 127.876 25.6575C127.876 26.8185 126.899 28.23 125.188 28.23ZM139.357 26.0745C137.701 26.0745 135.979 26.7885 135.271 28.371L137.305 29.2035C137.743 28.371 138.548 28.101 139.399 28.101C140.588 28.101 141.794 28.7985 141.812 30.03V30.1875C141.398 29.9535 140.51 29.607 139.417 29.607C137.226 29.607 134.994 30.7845 134.994 32.982C134.994 34.992 136.789 36.2865 138.806 36.2865C140.348 36.2865 141.199 35.607 141.734 34.8165H141.812V35.976H144.026V30.222C144.026 27.5625 141.992 26.0745 139.357 26.0745ZM139.081 34.2945C138.331 34.2945 137.286 33.9315 137.286 33.024C137.286 31.863 138.589 31.4175 139.717 31.4175C140.726 31.4175 141.199 31.635 141.812 31.9215C141.633 33.3105 140.408 34.2945 139.081 34.2945ZM152.092 26.403L149.457 32.9055H149.379L146.655 26.403H144.183L148.276 35.49L145.941 40.5465H148.336L154.642 26.403H152.092ZM131.43 36H133.728V21H131.43V36Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8251 9.04656C12.4641 9.41556 12.2551 9.99006 12.2551 10.7341V37.2721C12.2551 38.0161 12.4641 38.5906 12.8251 38.9596L12.9142 39.0406L28.1456 24.1756V23.8246L12.9142 8.95956L12.8251 9.04656Z",
    fill: "url(#paint0_linear_724_2404)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2174 29.133L28.1459 24.1755V23.8245L33.2235 18.867L33.3372 18.9315L39.3504 22.272C41.0665 23.22 41.0665 24.78 39.3504 25.734L33.3372 29.0685L33.2174 29.133Z",
    fill: "url(#paint1_linear_724_2404)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3375 29.0684L28.1462 23.9999L12.8257 38.9594C13.3957 39.5444 14.3252 39.6149 15.3822 39.0299L33.3375 29.0684Z",
    fill: "url(#paint2_linear_724_2404)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3375 18.9315L15.3822 8.97C14.3252 8.391 13.3957 8.4615 12.8257 9.0465L28.1462 24L33.3375 18.9315Z",
    fill: "url(#paint3_linear_724_2404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_724_2404",
    x1: 26.7932,
    y1: 37.5484,
    x2: 6.66009,
    y2: 16.9275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_724_2404",
    x1: 41.5851,
    y1: 23.9983,
    x2: 11.8452,
    y2: 23.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_724_2404",
    x1: 30.5146,
    y1: 21.2445,
    x2: 3.21249,
    y2: -6.71915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_724_2404",
    x1: 8.96927,
    y1: 47.7886,
    x2: 21.1609,
    y2: 35.3016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayDownloadBlack);
export default __webpack_public_path__ + "static/media/googlePlayDownloadBlack.1d6a8d0695d5e05730147caf370e1521.svg";
export { ForwardRef as ReactComponent };